import React, { useState, useMemo, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import qs from 'qs'
import mes from 'meinian-package/src/utils/message'
import Icon from 'meinian-package/src/component/icon'
import { PopoverCard } from 'meinian-package/src/baseComponent/dropdown'
import { getTeamInfo } from 'meinian-package/src/common/userInfo'
import util from 'meinian-package/src/utils/util'
import UploadIns from 'meinian-package/src/component/uploadIns'
import { teamHasAuth } from 'meinian-package/src/utils/auth'
import noPermissionPrompt from 'meinian-package/src/component/useFunModal/noPermissionPrompt'
import { MEMBER_TYPE } from 'meinian-package/src/component/enum'
import classNames from 'classnames'
import PanelCardList from '../../../../../component/cardList/panelCardList'
import ManagementSetting from '../../../../../component/navUser/managementSetting'
import workbenchForceGuide, { GUIDE_KEYS } from '../../forceGuideConfig'
import styles from './index.module.less'

const query = qs.parse(location.search, { ignoreQueryPrefix: true })
export default ({ width, wrapStyle, workUserInfo }) => {
  const history = useNavigate()
  const teamInfo = getTeamInfo()
  const [visible, setVisible] = useState(false)
  const _onChange = (val, curItem) => {
    util.track('mn-workbench-click', {
      module1: '功能板块',
      module2: curItem?.label,
    })
    if (val === '上传款式') {
      UploadIns.Show({
        inspirationId: query.inspirationId ? Number(query.inspirationId) : null,
        callback: () => {
          mes.pub('onMNUploadImage')
          mes.pub('onMNCreateIns')
        }
      })
    }
    if (val === '款式查重') {
      teamHasAuth('meinian_duplicate_images') ? history('/home/analysis/repeatCollect') : noPermissionPrompt({})
    }
    if (val === '智能分类') {
      history('/home/category-tags')
    }
    if (val === '采集插件') {
      window.open('https://meinian.zhiyitech.cn/tool/index.html')
    }
    if (val === '美念管理') {
      setVisible(true)
      return
    }
    if (val === '选款分析') {
      history('/home/analysis/choose')
    }
    if (val === '智能打标') {
      history('/home/workbench/marking')
    }
    if (val === '样衣管理') {
      history('/home/sample')
    }
  }

  const cancel = () => {
    setVisible(false)
  }
  const adminAuth = [MEMBER_TYPE.SUPER_ADMIN, MEMBER_TYPE.ADMIN].includes(Number(teamInfo?.memberType))

  const toolOption = useMemo(() => {
    return [
      { label: '样衣管理', icon: 'm-yangyiguanli', value: '样衣管理', auth: true },
      { label: '上传款式', icon: 'm-shangchuankuanshi', value: '上传款式', auth: true },
      { label: '款式查重', icon: 'm-kuanshichazhong', value: '款式查重', auth: true },
      { label: '智能分类', icon: 'm-zhinengfenlei', value: '智能分类', auth: true },
      { label: '采集插件', icon: 'm-caijichajian', value: '采集插件', auth: true },
      { label: '美念管理', icon: 'm-meinianguanli', value: '美念管理', auth: [MEMBER_TYPE.SUPER_ADMIN, MEMBER_TYPE.ADMIN].includes(Number(teamInfo?.memberType)) },
      { label: '选款分析', icon: 'm-xuankuanfenxi', value: '选款分析', auth: true },
      { label: '智能打标', icon: 'm-zhinengdabiao', value: '智能打标', auth: true },
    ]
  }, [teamInfo?.memberType])

  const domRef = useRef(null)
  workbenchForceGuide.useEmit(GUIDE_KEYS.STEP_2, domRef, workUserInfo)

  return <div className={styles['operation-panel-tool']} style={{ minWidth: width, ...wrapStyle }} ref={domRef}>
    <PanelCardList
      width={width}
      gridGap={8}
      itemMinWidth={122}
      maxColumnCount={4}
      options={toolOption.filter(item => item.auth)}
      beforeSetOption={(_option, span) => {
        const more = { label: '更多', value: '更多' }
        if (span === 3) {
          _option.pop()
          _option.push(more)
        }
        return _option
      }}
      renderCard={({ data, style, itemPadding }) => <OperationPanelCard
        moreOption={toolOption.slice(toolOption.length - (adminAuth ? 3 : 2), toolOption.length)} // 硬性适配
        key={data.label}
        style={{ ...style, paddingLeft: itemPadding, paddingRight: itemPadding }}
        data={data}
        onChange={_onChange}
      />}
    />
    <ManagementSetting
      visible={visible}
      onClose={cancel}
      onVisibleChange={vis => setVisible(vis)}
    />
  </div>
}

const OperationPanelCard = ({ moreOption, data, style, onChange }) => {
  if (data.label === '更多') {
    const content = (<div className="operation-panel-tool-content">
      {moreOption.map(item => <div key={item.label} className={classNames('operation-panel-tool-item fill-white-bg', { more: true })} onClick={() => onChange(item.value, item)}>
        <Icon type={item.icon} className="operation-panel-tool-item-icon" />
        <div className="operation-panel-tool-item-text">{item.label}</div>
      </div>)}
    </div>)
    return <PopoverCard
      placement="rightTop"
      content={content}
      trigger="click"
      getPopupContainer={triggerNode => triggerNode}
      overlayClassName="operation-panel-tool-dropdown"
      overlayStyle={{ paddingLeft: '14px' }}
    >
      <div key={data.label} className="operation-panel-tool-item fill-white-bg" style={style}>
        <div className="operation-panel-tool-item-text">{data.label}</div>
        <Icon type="m-Vxing_you" className="operation-panel-tool-item--more-icon" />
      </div>
    </PopoverCard>
  }
  return <div key={data.label} className="operation-panel-tool-item fill-white-bg" style={style} onClick={() => onChange(data.value, data)}>
    <Icon type={data.icon} className="operation-panel-tool-item-icon" />
    <div className="operation-panel-tool-item-text">{data.label}</div>
  </div>
}
